import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Avatar from 'react-avatar';
import { Waypoint } from 'react-waypoint';
import { Container, Loader } from 'semantic-ui-react';
import { Media, breakpoints } from '../../../../mediaSetting.js';
import { useMediaQuery } from 'react-responsive';
import { getUserAvatarText } from 'businessLogic/userAvatar';
import { convertToLocalMoment } from 'businessLogic/datetime';
import {
  getAllUsersForAdmin,
  updateCurrentActivePageNo,
  updateAllUsersSearchBar,
  resetAllUsersSearchForm,
  updateAllUsersSearchForm,
  updateSingleUsersForAdmin,
} from 'actions/user';
import { showHideMenu } from 'components/shared/contextualMenu/content';
import moment from 'moment';
import ScrollToTopButton from '../../../shared/scrollToTopBtn/content';
import SearchContainer from './searchContainer';

import ManageAllUsersActionsMenu from './ManageAllUsersContextualMenu';

const AllUsersLisingPageCenterPanelContainer = (props) => {
  const isMobileOrTablet = useMediaQuery({
    query: `(max-width: ${breakpoints.computer}px)`,
  });

  const [allUsersSelected, selectAllUsersSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const currentAllUsersIsFormSubmitted = useSelector((state) => state.usersReducer.currentAllUsersIsFormSubmitted);
  const isAdmin = useSelector((state) => state.usersReducer.userProfile.isAdmin);

  const onSearchTermInputChange = (e) => {
    if (e.target != undefined)
      props.dispatch(updateAllUsersSearchBar({ searchString: e.target.value, isFormSubmitted: false }));
    else props.dispatch(updateAllUsersSearchBar({ searchString: e, isFormSubmitted: false }));
  };

  const handleSearchKeyUp = (event) => {
    if (event.keyCode === 13) {
      // Cancel the default action, if needed
      event.preventDefault();
      submitSearchTerm(true);
    }
  };

  const submitSearchTerm = (isFormSubmitted) => {
    let searchString = document.getElementById('searchBarInput').value || '';
    props.dispatch(updateAllUsersSearchBar({ searchString: searchString, isFormSubmitted: isFormSubmitted || false }));
    if (!isLoading) {
      // Reset users list form
      props.dispatch(resetAllUsersSearchForm());
      // Store current search string
      let currentActivePageNo = 0;
      let fetchingPageNo = currentActivePageNo + 1;
      let allUsersSearchFormPayLoad = {
        pageSize: props.searchPageSize,
        searchString: searchString.trim(),
        pageNo: fetchingPageNo,
      };
      props.dispatch(updateAllUsersSearchForm(allUsersSearchFormPayLoad));

      setIsLoading(true);
      let cb = (moreUsersAreReturned) => {
        setIsLoading(false);

        if (moreUsersAreReturned) {
          // Once data fetch finishes and fetched users.length > 0, the active page no needs to be increased by 1
          props.dispatch(updateCurrentActivePageNo(1));
        }
      };
      props.dispatch(getAllUsersForAdmin(allUsersSearchFormPayLoad, cb));
    }
  };

  const clearSearchTerm = () => {
    props.dispatch(updateAllUsersSearchBar({ searchString: '' }));
    setTimeout(() => {
      submitSearchTerm();
    }, 500);
  };

  // Commenting because its not being used, and can be deleted after reviewing
  // const selectAllUsers = (allUsersSelected) => {
  //   selectAllUsersSelected(allUsersSelected)
  // };

  const handleWaypointEnter = () => {
    let currentActivePageNo = props.allUsersSearchForm.currentActivePageNo;
    let fetchingPageNo = currentActivePageNo + 1;
    // Check if max rows limit has been reached
    if (
      props.allUsersSearchForm.totalRowsForSet == null ||
      parseInt(props.searchPageSize, 10) * parseInt(currentActivePageNo, 10) < props.allUsersSearchForm.totalRowsForSet
    ) {
      if (!isLoading) {
        setIsLoading(true);
        let cb = (moreUsersAreReturned) => {
          setIsLoading(false);

          if (moreUsersAreReturned) {
            // Once data fetch finishes, the active page no needs to be increased by 1
            props.dispatch(updateCurrentActivePageNo(1));
          }
        };
        let allUsersSearchFormPayLoad = {
          pageSize: props.searchPageSize,
          searchString: props.allUsersSearchForm.searchString.trim(),
          pageNo: fetchingPageNo,
        };
        props.dispatch(getAllUsersForAdmin(allUsersSearchFormPayLoad, cb));
      }
    }
  };

  const getUserNameText = (user) => {
    if (user.isEmailOnlyUser) return user.email;

    return user.firstName + ' ' + user.lastName;
  };

  const getUserRolesText = (user, timezone) => {
    const invitedOnLatestUtcTime = user.invitedOn;
    let invitedOnLatestLocalTimeText = '';
    if (timezone == 0 || !!timezone) {
      const invitedOnLatestLocalTime =
        timezone == 0 || !!timezone ? convertToLocalMoment(moment(invitedOnLatestUtcTime), timezone) : '';
      const invitedOnLatestLocalFormatedDate = invitedOnLatestLocalTime.format(APP.LANGUAGE.MainReport.DateFormat);
      const momentToday = moment().utcOffset(timezone);

      if (momentToday.format(APP.LANGUAGE.MainReport.DateFormat) === invitedOnLatestLocalFormatedDate) {
        invitedOnLatestLocalTimeText = 'today';
      } else if (
        momentToday.subtract(1, 'days').format(APP.LANGUAGE.MainReport.DateFormat) === invitedOnLatestLocalFormatedDate
      ) {
        invitedOnLatestLocalTimeText = 'yesterday';
      } else {
        invitedOnLatestLocalTimeText = 'on ' + invitedOnLatestLocalFormatedDate;
      }
    }

    return `Invited ${invitedOnLatestLocalTimeText}`;
  };

  const renderUserRow = (userArray, isOnMobileOrTablet) => {
    if (userArray.length > 0) {
      return userArray.map((user, index) => {
        let isInvitedUser = user.firstName == null && user.lastName == null;
        let avatarText = isInvitedUser ? '@' : getUserAvatarText(user);
        const avatarSizeMobile = 50;
        const avatarSizeTabletComputer = 33;
        let userNameMarkup = '';
        let userEntityMarkup = '';
        if (isInvitedUser) {
          // Email only users (invited users)
          if (props.timezone == 0 || !!props.timezone) {
            userNameMarkup = (
              <div>
                <Container fluid as={Media} greaterThanOrEqual="tablet" className="wrap-link">
                  {user.email}
                  <span style={{ fontStyle: 'italic' }}>{` (` + getUserRolesText(user, props.timezone) + `)`}</span>
                </Container>
                <Container fluid as={Media} at="mobile" className="wrap-link">
                  {user.email}
                  <div className="text-size-ms secondary-text" style={{ fontStyle: 'italic' }}>
                    {` (` + getUserRolesText(user, props.timezone) + `)`}
                  </div>
                </Container>
              </div>
            );
          }
        } else {
          userNameMarkup = getUserNameText(user);

          if (user.organisationCount != 0 || user.waitingAreasCount != 0 || user.meetingRoomsCount != 0) {
            let orgCountMarkup =
              user.organisationCount != 0
                ? user.organisationCount == 1
                  ? `${user.organisationCount} Organisational Unit`
                  : `${user.organisationCount} Organisational Units`
                : '';
            let waCountMarkup =
              user.waitingAreasCount != 0
                ? user.waitingAreasCount == 1
                  ? `${user.waitingAreasCount} Waiting Area`
                  : `${user.waitingAreasCount} Waiting Areas`
                : '';
            let mrCountMarkup =
              user.meetingRoomsCount != 0
                ? user.meetingRoomsCount == 1
                  ? `${user.meetingRoomsCount} Meeting Room`
                  : `${user.meetingRoomsCount} Meeting Rooms`
                : '';
            userEntityMarkup =
              ` (` +
              orgCountMarkup +
              (orgCountMarkup != '' && waCountMarkup != '' ? `, ` + waCountMarkup : waCountMarkup) +
              ((waCountMarkup != '' && mrCountMarkup != '') ||
              (orgCountMarkup != '' && waCountMarkup == '' && mrCountMarkup != '')
                ? `, ` + mrCountMarkup
                : mrCountMarkup) +
              `)`;
          } else {
            userEntityMarkup = APP.LANGUAGE.ManageAllUsers.NoRolesAssign;
          }
        }

        return (
          <div
            className={`${isOnMobileOrTablet ? 'row flexible row-hoverable mrlm mrrm' : 'row flexible row-hoverable'}
              ${isAdmin && user.personStatus === 'I' ? 'inactive-user' : ''}`}
            key={index}
            onClick={(event) => {
              // Get the current row that onClick is listening, then get the checkbox element in this row
              user.personStatus !== 'I' &&
                showHideMenu(null, '.manage-users-all-container', index, event.target, event.currentTarget, 200);
              user.personStatus !== 'I' && props.dispatch(updateSingleUsersForAdmin(user.personId));
            }}
          >
            {/* Column #1 - Avatar + User name (7 wide for tablet and above / full 16 wide on mobile) */}
            <div className="tablet only computer only column left-column-fixed status-column left-text users-column inline-flex center-flex max-width">
              <div className="fl" style={{ height: avatarSizeTabletComputer + 'px' }}>
                <Avatar
                  round={true}
                  size={avatarSizeTabletComputer}
                  src={user.profileImageUrl}
                  name={!!user.profileImageUrl ? null : avatarText}
                  className="user-avatar"
                  color={isInvitedUser ? window.styleVariable.primaryHoverColour : ''}
                  textSizeRatio={2.5}
                />
              </div>
              <div className="pdls pdrs">
                {userNameMarkup}
                {userEntityMarkup} {isAdmin && user.personStatus === 'I' && `(${user.email})`}
              </div>
            </div>

            {/* Column #2 - User roles - (shown only on tablet and above) */}
            <div
              className="mobile only column pdlnull pdrnull left-text inline-flex center-flex"
              style={{ width: 'calc(100% - 20px)' }}
            >
              <Avatar
                round={true}
                size={avatarSizeMobile}
                src={user.profileImageUrl}
                name={!!user.profileImageUrl ? null : avatarText}
                className="user-avatar"
                color={isInvitedUser ? window.styleVariable.primaryHoverColour : ''}
                textSizeRatio={2}
              />

              <div className="mrlm" style={{ width: 'calc(100% - 75px)' }}>
                {userNameMarkup}
                <div className="text-size-ms secondary-text">{userEntityMarkup}</div>
                <div className="text-size-ms secondary-text">
                  {isAdmin && user.personStatus === 'I' && `(${user.email})`}
                </div>
              </div>
            </div>
            <ManageAllUsersActionsMenu isAdmin={isAdmin} selectedUser={user} dispatch={props.dispatch} />
          </div>
        );
      });
    } else {
      return isLoading ? (
        ''
      ) : (
        <div className="row flexible row-hoverable">
          <div className="column text-size-ml max-width">{APP.LANGUAGE.ManageAllUsers.NoResults}</div>
        </div>
      );
    }
  };

  const tableHeaderMarkup = (
    <div className="row flexible color-organisational-unit-bg pdtnull pdbnull header-row">
      {/* Column #1 header */}
      <span className="ui nine wide tablet only nine wide computer only eight wide mobile column color-white display-flex">
        <div className="color-white max-width pdxs left-text">{APP.LANGUAGE.ManageAllUsers.ColumnHeader}</div>
      </span>

      {/* Column #2 header */
      /* autoComplete needs to set a random string in input to disable auto fill, and attr name to contains search as a string for Safari*/}
      <span className="ui seven wide tablet  seven wide computer eight wide mobile column  icon input color-white display-flex pdlnull">
        <SearchContainer
          onChange={(e) => {
            onSearchTermInputChange(e);
          }}
          id="searchBarInput"
          className="ui color-white input color-organisational-unit-bg-highlight max-width pdxs"
          maxlength="500"
          onKeyUp={handleSearchKeyUp}
          placeholder={APP.LANGUAGE.ManageAllUsers.SearchPlaceholder}
          autoComplete="not-enable"
          disabled={isLoading}
        />
        {!currentAllUsersIsFormSubmitted ? (
          <i className="search icon mrrml hand" onClick={submitSearchTerm} style={{ pointerEvents: 'auto' }} />
        ) : (
          <i
            className="delete icon mrrml hand"
            onClick={clearSearchTerm}
            style={{ pointerEvents: 'auto', opacity: !isLoading ? 1 : '' }}
          />
        )}
      </span>
    </div>
  );

  return (
    <div>
      <Container fluid as={Media} lessThan="computer" className="ui center aligned padded grid">
        {tableHeaderMarkup}
        {renderUserRow(props.usersIcanManageForAdmin, true)}
        {isMobileOrTablet && (
          <Waypoint onEnter={handleWaypointEnter}>
            <div className="waypoint mrts mrbs" />
          </Waypoint>
        )}
        {isLoading ? (
          <div className="mrtm mrbm">
            <Loader active inline="centered" />
          </div>
        ) : (
          ''
        )}
      </Container>
      <Container fluid className="ui center aligned padded grid" as={Media} greaterThanOrEqual="computer">
        {tableHeaderMarkup}
        <div className="desktop-scrolling-wrapper max-width pdlnull pdrnull">
          <div className="ui center aligned padded grid pdlnull pdrnull" id="desktop-scrolling-wrapper-users">
            {
              <div className="row flexible row-hoverable" /> /* Have to add this empty div with .row class, to show the bottom border for other rows */
            }
            {renderUserRow(props.usersIcanManageForAdmin, false)}
            {isLoading ? (
              <div className="mrtm mrbxl">
                <Loader active inline="centered" />
              </div>
            ) : (
              <div className="flexible row-hoverable" style={{ height: '150px' }} />
            )}
            {!isMobileOrTablet && (
              <Waypoint onEnter={handleWaypointEnter}>
                <div className="waypoint" />
              </Waypoint>
            )}
          </div>
          <ScrollToTopButton className="scroll-top-btn-mobile" targetElement=".desktop-scrolling-wrapper-users" />
        </div>
      </Container>
    </div>
  );
};
export default AllUsersLisingPageCenterPanelContainer;
